<template>
  <div class="col-12">
    <Search
      :title="$lang.cooperation_list_title"
      :allowFields="$lang.cooperation_allow_fields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      :isLoading="isLoading"
      removeModalSize="lg"
      addModalSize="lg"
      :dynamicButtons="dynamicButtons"
      ref="search"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(permissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddOrder @close="search.close" @getData="getData" />
      </template>
    </Search>
    <b-modal v-model="editModal" size="lg" hide-footer hide-header>
      <EditOrder :id="editId" @close="closeEditModal" @getData="getData" />
    </b-modal>
    <b-modal v-model="dailyWorkingModal" hide-footer hide-header>
      <AddDailyWorking @close="closeDailyWorkingModal" @getData="getData" />
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddOrder from "./addOrder.vue";
import EditOrder from "./editOrder.vue";
import AddDailyWorking from "../dailyWorking/addDailyWorking.vue";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";
import { computed } from "vue";

export default {
  components: {
    Search,
    AddOrder,
    EditOrder,
    AddDailyWorking,
  },
  provide() {
    /* guidance: provide this data to all deep child components */
    return {
      PERMISSIONS: computed(() => this.permissions),
      COOPERATION_DATE: computed(() =>
        pathOr(null, ["order_execute_date"], this.dailyWorkingItem)
      ),
      WORK_ORDER: computed(() => {
        return {
          id: pathOr(null, ["id"], this.dailyWorkingItem),
          company: pathOr(null, ["company"], this.dailyWorkingItem),
          order_kind: pathOr(null, ["order_kind"], this.dailyWorkingItem),
        };
      }),
    };
  },
  data() {
    return {
      dynamicButtons: [
        {
          name: "edit",
          text: this.$lang.add_new_daily_working,
          AllowPermissions: ["admin", "edit"],
          iconFont: {
            name: "briefcase-plus-outline",
            size: "24",
            class: "text-primary",
          },
          click: this.showDailyWorkingModal,
        },
        {
          name: "edit",
          text: this.$lang.daily_working_list_title,
          AllowPermissions: ["admin", "edit"],
          iconFont: {
            name: "briefcase-eye-outline",
            size: "24",
            class: "text-warning",
          },
          click: this.showWorkingList,
        },
        {
          name: "edit",
          text: this.$lang.download_order_worksheets,
          AllowPermissions: ["admin", "edit"],
          iconFont: {
            name: "briefcase-download-outline",
            size: "24",
            class: "text-info",
          },
          click: this.downloadWorksheets,
        },
        {
          id: "0",
          name: "edit",
          click: this.showEditModal,
        },
        {
          id: "1",
          name: "view",
          click: this.showEditModal,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      permissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
      editModal: false,
      editId: null,
      dailyWorkingModal: false,
      dailyWorkingItem: null,
      isLoading: false,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["cooperation", "order"]);
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    getData() {
      this.$refs.search.getItems();
    },
    updatePermissions(permissions) {
      this.permissions = permissions;
    },
    showEditModal(item) {
      this.editId = pathOr(null, ["id"], item);
      this.editModal = true;
    },
    closeEditModal() {
      this.editId = null;
      this.editModal = false;
    },
    showDailyWorkingModal(item) {
      this.dailyWorkingItem = item;
      this.dailyWorkingModal = true;
    },
    closeDailyWorkingModal(item) {
      this.dailyWorkingModal = false;
    },
    showWorkingList(item) {
      const id = pathOr(null, ["id"], item);
      goToRoute("search_daily_working", { id });
    },
    async downloadWorksheets(item) {
      try {
        this.isLoading = true;
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(["cooperation", "order_report_id"], [id]);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        window.open(data, "_blank");
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
